// import React, { useState, useEffect } from 'react';
// import Slider from 'react-slick';
// import axios from 'axios';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { useNavigate } from 'react-router-dom';
// import './ImageSlider.css'

// const ImageSlider = () => {
//   const img2 = [{
//     name: 'Air Conditioners',
//     url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/aircondition.png'
//   }, {
//     name: 'cooler',
//     url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/cooler.png'
//   }, {
//     name: 'Mobile & TAB',
//     url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/Mobiel&TAB.png'
//   }, {
//     name: 'TV',
//     url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/TV.png'
//   }, {
//     name: 'microwave',
//     url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/microwave.png'
//   }, {
//     name: 'camera',
//     url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/camera_slider.png'
//   }, {
//     name: 'computer & laptop',
//     url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/computerandlaptop.png'
//   }, {
//     name: 'bluetooth speaker',
//     url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/bluetoothspeaker.png'
//   }, {
//     name: 'mixer grinder',
//     url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/mixergrinder.png'
//   }]
//   // const [images, setImages] = useState([]);
//   const navigate = useNavigate();

//   // useEffect(() => {
//   //   const fetchImages = async () => {
//   //     try {
//   //       // Replace 'your-api-url' with the actual API URL
//   //       const response = await axios.get('https://pixabay.com/api/?key=43791671-19e2af4611789d09947044d02&q=electronics&image_type=photo');
//   //       // Extract the image URLs from the hits array
//   //       const imageUrls = response.data.hits.map(hit => hit.largeImageURL);
//   //       setImages(imageUrls);
//   //     } catch (error) {
//   //       console.error('Error fetching images:', error);
//   //     }
//   //   };

//   //   fetchImages();
//   // }, []); // The empty array ensures the effect runs only once after the initial render

//   const settings = {
//     infinite: true,
//     speed: 500,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     responsive: [
//       {
//         breakpoint: 768, // Mobile screen size and below
//         settings: {
//           slidesToShow: 5,
//         },
//       },
//       {
//         breakpoint: 480, // Small mobile screens
//         settings: {
//           slidesToShow: 3,
//         },
//       },
//     ],
//     slidesToShow: 8, // Default for larger screens
//   };
//   //navigate(`/category/${imgUrl.name}`) 

//   return (
//     <div className='image-slider-container'>
//       <Slider {...settings} className='image-slider-slider'>
//         {img2.map((imgUrl, index) => (
//           <div key={index} className='image-slider-item-container'>
//             <img src={imgUrl.url} alt={`Slide ${index + 1}`} onClick={() => window.open(`/category/${imgUrl.name}`, '_blank', 'noopener,noreferrer')} className='image-slider-item' />
//           </div>
//         ))}
//       </Slider>
//     </div>
//   );
// };

// export default ImageSlider;


import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from 'react-router-dom';
import './ImageSlider.css';

// Custom arrow components
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className="custom-arrow-small-slider custom-prev-arrow-small"
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </div>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className="custom-arrow-small-slider custom-next-arrow-small"
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18l6-6-6-6" />
      </svg>
    </div>
  );
};

const ImageSlider = () => {
  const img2 = [{
    name: 'Air Conditioners',
    url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/aircondition.png'
  }, {
    name: 'cooler',
    url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/cooler.png'
  }, {
    name: 'Mobile & TAB',
    url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/Mobiel&TAB.png'
  }, {
    name: 'TV',
    url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/TV.png'
  }, {
    name: 'microwave',
    url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/microwave.png'
  }, {
    name: 'camera',
    url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/camera_slider.png'
  }, {
    name: 'computer & laptop',
    url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/computerandlaptop.png'
  }, {
    name: 'bluetooth speaker',
    url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/bluetoothspeaker.png'
  }, {
    name: 'mixer grinder',
    url: 'https://khoslaslider.s3.ap-south-1.amazonaws.com/category/mixergrinder.png'
  }];

  const navigate = useNavigate();

  const settings = {
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 768, // Mobile screen size and below
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 480, // Small mobile screens
        settings: {
          slidesToShow: 3,
        },
      },
    ],
    slidesToShow: 8, // Default for larger screens
  };

  return (
    <div className='image-slider-container'>
      <Slider {...settings} className='image-slider-slider'>
        {img2.map((imgUrl, index) => (
          <div key={index} className='image-slider-item-container'>
            <img
              src={imgUrl.url}
              alt={`Slide ${index + 1}`}
              onClick={() => window.open(`/category/${imgUrl.name}`, '_blank', 'noopener,noreferrer')}
              className='image-slider-item'
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;